<template>
  <AdminNavbar>
    <div></div>
  </AdminNavbar>
</template>

<script>
import AdminNavbar from "@/components/admin/AdminNavbar";

export default {
  name: "MWUpdateHome",
  components: {
    AdminNavbar,
  },
  setup() {
    return {};
  },
};
</script>
